module.exports = __webpack_public_path__ + "img/36-s.09fc2e38.png";